module.exports = __webpack_public_path__ + "img/asb_logo.a50e8bc1.svg";